const LopTokenKey = 'lopAccessToken';

// lop服务器登录态维护
export function getLopToken() {
  return localStorage.getItem(LopTokenKey);
}

export function setLopToken(token) {
  localStorage.setItem(LopTokenKey, token);
}

export function removeLopToken() {
  localStorage.removeItem(LopTokenKey);
}

/**
 * 根据lop服务器登录态token存取手机号，用作用户信息记录。
 */
export function setUserPhone(token, mobile) {
  localStorage.setItem(token, mobile);
}

export function getUserPhone(token) {
  return localStorage.getItem(token);
}

// 昵称持久化维护
export function setStoredUserName(phone, name) {
  localStorage.setItem(`nick_${phone}`, name);
}

export function getStoredUserName(phone) {
  return localStorage.getItem(`nick_${phone}`);
}
